import styled from "styled-components";

const ContactStyleWrapper = styled.section`
  padding: 110px 0;
  background: #0d102d;

  .get_in_touch_title{
    font-size: 48px;
    color: #ffffff;
    margin-bottom: 50px;
    text-align: center;
  }

  .get_in_touch{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;

    .get_in_touch_item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
      padding: 30px;
      border : 1px solid #FF06B7;
      border-radius: 10px;
      width: 30%;

      .icon{
        background: #FF06B7;
        padding: 15px;
        border-radius: 50%;
        margin-bottom: 20px;
      }

      svg{
        color: #FFFFFF;
        font-size: 30px;
      }

      h6{
        font-size: 22px;
        color: #ffffff;
        margin-bottom: 10px;
      }

      p{
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        margin-bottom: 0;
      }
    }
  }

  .submit_btn{
    margin-top: 40px;
  }

  .input_form_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 30px;
    
    .form_box{
      width: 48%;
    }
  }

  label {
    font-family: "Poppins";
    text-transform: uppercase;
    color: rgba(255, 255, 255);
    line-height: 45px;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 5px;
  }

  input,
  textarea {
    border: 1px solid #FF06B7;
    background: transparent;
    outline: none;
    padding: 8px 21px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    width: 100%;
    box-sizing: border-box;
  }

  input {
    height: 60px;
  }

  textarea {
    height: 130px;
    resize: none;
  }

  @media only screen and (max-width: 991px) {
    padding: 60px 0 100px;

    .get_in_touch{
      .get_in_touch_item{
        width: 100%;
      }
    }

    .input_form_box {
      margin-bottom: 0px;

      .form_box{
        width: 100%;
        margin-bottom: 20px;
      }
    }

  }

  @media only screen and (max-width: 767px) {
    padding: 40px 0 80px;

    .get_in_touch{
      .get_in_touch_item{
        padding: 20px;
      }
    }

    .get_in_touch_title{
      font-size: 30px;
      margin-bottom: 30px;
    }
  }
`;

export default ContactStyleWrapper;
